var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z",
    fill: "#662D91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6667 23.3333C20.6667 26.2789 23.0546 28.6667 26.0001 28.6667C28.9456 28.6667 31.3334 26.2789 31.3334 23.3333C31.3334 20.3878 28.9456 18 26.0001 18C23.0546 18 20.6667 20.3878 20.6667 23.3333ZM34.0001 28.6667C34.0001 30.8758 35.7909 32.6667 38.0001 32.6667C40.2092 32.6667 42.0001 30.8758 42.0001 28.6667C42.0001 26.4575 40.2092 24.6667 38.0001 24.6667C35.7909 24.6667 34.0001 26.4575 34.0001 28.6667Z",
    fill: "#662D91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9778 31.3335C19.6826 31.3335 14.5177 34.5689 14.0009 40.9324C13.9727 41.2791 14.6356 42.0002 14.97 42.0002H36.9956C37.9972 42.0002 38.0128 41.1941 37.9972 40.9335C37.6065 34.3911 32.3616 31.3335 25.9778 31.3335ZM45.2746 42.0002L40.1333 42.0002C40.1333 38.9989 39.1417 36.2293 37.4683 34.001C42.0103 34.0506 45.7189 36.347 45.998 41.2002C46.0092 41.3956 45.998 42.0002 45.2746 42.0002Z",
    fill: "#662D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTapsIcon);
export default __webpack_public_path__ + "static/media/total-taps-icon.faeb83bc031e077e9c68edb55f76726a.svg";
export { ForwardRef as ReactComponent };